
import { computed, onMounted, ref } from 'vue';
import Button from 'primevue/button';
import Message from 'primevue/message';
import { game } from '../apis/game';
import { GamesList, GameStatusResult } from '../types/game';
import GameNavbar from '../components/navbar/GameNavbar.vue';

import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { showVuePopup } from '../utils/showVuePopup';
import Login from '../popup/Login.vue';
import { useToast } from 'primevue/usetoast';

export default {
	name: 'Sport',
	components: {
		IconField,
		InputIcon,
		InputText,
		Button,
		Message,
		GameNavbar,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		onMounted(async () => {
			await handleGameStatus();
			await handleProducts();
		});

		const error = ref<string | null>(null);
		const loadingProducts = ref(true);

		const gameState = ref<GameStatusResult>({
			card: false,
			casino: false,
			cock: false,
			esport: false,
			fish: false,
			keno: false,
			lotto: false,
			poker: false,
			slot: false,
			sport: false,
			trade: false,
		});

		const selectedProduct = ref<GamesList>();
		const products = ref<GamesList[]>([]);
		const searchQuery = ref('');

		const filteredProducts = computed(() => {
			return products.value.filter((product) =>
				product.productName?.toLowerCase().includes(searchQuery.value.toLowerCase())
			);
		});

		const handleGameStatus = async () => {
			try {
				const resp = await game.status();
				if (resp.code !== '0') throw new Error(resp.message);
				gameState.value = resp.result as GameStatusResult;
			} catch (err: any) {
				error.value = err.message;
			}
		};

		const handleProducts = async () => {
			loadingProducts.value = true;
			error.value = null;

			try {
				const requests = [
					game.listByCode({ gameType: 11, productCode: 'SBO' }),
					game.listByCode({ gameType: 12, productCode: 'SABA' }),
					game.listByCode({ gameType: 13, productCode: 'DBS' }),
					game.listByCode({ gameType: 14, productCode: 'FBS' }),
					game.listByCode({ gameType: 15, productCode: 'PLB' }),
					game.listByCode({ gameType: 16, productCode: 'UMB' }),
					game.listByCode({ gameType: 17, productCode: 'VBS' }),
					game.listByCode({ gameType: 18, productCode: 'AFB' }),
					game.listByCode({ gameType: 19, productCode: 'LALI' }),
					game.listByCode({ gameType: 20, productCode: 'WSS' }),
					game.listByCode({ gameType: 21, productCode: 'M9' }),
					game.listByCode({ gameType: 22, productCode: 'UFA' }),
				];

				const responses = await Promise.all(requests);
				products.value = responses.flatMap((res: any) => res.result?.gamesList || []);
			} catch (err: any) {
				error.value = err.message;
			} finally {
				loadingProducts.value = false;
			}
		};

		const handleFavoriteAdd = async (code: string) => {
			try {
				const resp = await game.favoriteAdd(code);
				if (resp.code !== '0') throw new Error(resp.message);

				toast.add({
					severity: 'success',
					summary: resp.message,
					detail: 'เพิ่มลงรายการโปรดสำเร็จ',
					life: 3000,
				});
			} catch (err: any) {
				error.value = err.message;
			}
		};

		const handleFavoriteRemove = async (code: string) => {
			try {
				const resp = await game.favoriteDelete(code);
				if (resp.code !== '0') throw new Error(resp.message);

				toast.add({
					severity: 'success',
					summary: resp.message,
					detail: 'ลบรายการโปรดสำเร็จ',
					life: 3000,
				});
			} catch (err: any) {
				error.value = err.message;
			}
		};

		const clickGame = async (code: string) => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login);
				return;
			}

			const found = products.value.find((p) => p.loginCode === code);
			if (found) {
				selectedProduct.value = found;

				try {
					const payload = {
						gameType: 1,
						productCode: found.productCode,
						code: code,
						redirect: window.location.origin,
						isMobile: true,
					};
					const resp = await game.login(payload);
					if (resp.code !== '0') throw new Error(resp.message);

					window.open(resp?.url, '_blank');
				} catch (err: any) {
					error.value = err.message;
				}
			}
		};

		const clickSport = async () => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login);
				return;
			}

			try {
				const payload = {
					redirect: window.location.origin,
				};
				const resp = await game.sport(payload);
				if (resp.code !== '0') throw new Error(resp.message);

				console.log(resp.message);
			} catch (err: any) {
				error.value = err.message;
			}
		}

		const clickBtnFavorite = async (code: string, actionOld: boolean) => {
			try {
				if (actionOld) {
					await handleFavoriteRemove(code);
				} else {
					await handleFavoriteAdd(code);
				}
			} catch (err: any) {
				error.value = err.message;
			} finally {
				await handleProducts();
			}
		};

		return {
			auth,
			filteredProducts,
			searchQuery,
			selectedProduct,
			clickGame,
			clickSport,
			clickBtnFavorite,
			error,
			loadingProducts,
		};
	},
};
